var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container oiline-shop-add-goods" },
    [
      _c(
        "el-form",
        {
          ref: "addGoodsForm",
          staticClass: "add-goods-form",
          attrs: { model: _vm.formData, "label-position": "right" }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "选择店铺：" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "搜索条件"
                          },
                          on: {
                            change: function($event) {
                              return _vm.inputChange($event)
                            }
                          },
                          model: {
                            value: _vm.formData.sellerId,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "sellerId", $$v)
                            },
                            expression: "formData.sellerId"
                          }
                        },
                        _vm._l(_vm.sellerOptions, function(item) {
                          return _c("el-option", {
                            key: item.sellerId,
                            attrs: {
                              label: item.sellerName,
                              value: item.sellerId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "详情页商品名称：" }
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入内容" },
                        on: {
                          input: function($event) {
                            return _vm.inputChange($event)
                          }
                        },
                        model: {
                          value: _vm.formData.goodsDetailTitle,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "goodsDetailTitle", $$v)
                          },
                          expression: "formData.goodsDetailTitle"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "是否热卖：" }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.isHot,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "isHot", $$v)
                            },
                            expression: "formData.isHot"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { label: 1 } },
                            [
                              _c(
                                "el-tag",
                                { attrs: { effect: "plain", type: "danger" } },
                                [_vm._v("热卖")]
                              )
                            ],
                            1
                          ),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "是否推荐：" }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.isRecommend,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "isRecommend", $$v)
                            },
                            expression: "formData.isRecommend"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { label: 1 } },
                            [
                              _c(
                                "el-tag",
                                { attrs: { effect: "plain", type: "danger" } },
                                [_vm._v("推荐")]
                              )
                            ],
                            1
                          ),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "提货方式：" }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.logisticsTypes,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "logisticsTypes", $$v)
                            },
                            expression: "formData.logisticsTypes"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("门店自提")
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("包邮")
                          ]),
                          _c("el-radio", { attrs: { label: "1,2" } }, [
                            _vm._v("包邮或门店自提")
                          ])
                        ],
                        1
                      ),
                      _vm.formData.logisticsTypes.indexOf("1") !== -1
                        ? _c(
                            "div",
                            { staticClass: "bairun-grey-pannel" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: _vm.handleSellerCheckAllChange
                                  },
                                  model: {
                                    value: _vm.sellerCheckAll,
                                    callback: function($$v) {
                                      _vm.sellerCheckAll = $$v
                                    },
                                    expression: "sellerCheckAll"
                                  }
                                },
                                [_vm._v("全选")]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  on: { change: _vm.handleCheckedSellerChange },
                                  model: {
                                    value: _vm.formData.logisticsSellerIds,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "logisticsSellerIds",
                                        $$v
                                      )
                                    },
                                    expression: "formData.logisticsSellerIds"
                                  }
                                },
                                _vm._l(_vm.sellerOptions, function(item) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: item.sellerId,
                                      attrs: { label: item.sellerId }
                                    },
                                    [_vm._v(_vm._s(item.sellerName))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序(值大优先)：" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, placeholder: "请输入内容" },
                        model: {
                          value: _vm.formData.weight,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "weight", $$v)
                          },
                          expression: "formData.weight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 50 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "关联商品：" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "bairun-grey-pannel" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", icon: "el-icon-add" },
                              on: {
                                click: function($event) {
                                  return _vm.onAddGoods()
                                }
                              }
                            },
                            [_vm._v("添加商品")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "goods-size-content bairun-margin-t"
                            },
                            [
                              _vm._l(_vm.goodsSize, function(item, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: item,
                                    attrs: {
                                      closable: "",
                                      "disable-transitions": false
                                    },
                                    on: {
                                      close: function($event) {
                                        return _vm.onDeleteSize(null, index)
                                      }
                                    }
                                  },
                                  [_vm._v(" " + _vm._s(item) + " ")]
                                )
                              }),
                              _vm.goodsSizeVisible
                                ? _c("el-input", {
                                    ref: "goodsSizeValue",
                                    staticClass: "goods-size",
                                    attrs: { size: "small" },
                                    on: {
                                      blur: function($event) {
                                        return _vm.onAddSize()
                                      }
                                    },
                                    nativeOn: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.onAddSize()
                                      }
                                    },
                                    model: {
                                      value: _vm.goodsSizeValue,
                                      callback: function($$v) {
                                        _vm.goodsSizeValue = $$v
                                      },
                                      expression: "goodsSizeValue"
                                    }
                                  })
                                : _c(
                                    "el-button",
                                    {
                                      staticClass: "add-goods-size",
                                      attrs: { size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onShowInputSize(
                                            null,
                                            "goodsSizeValue"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("+批量添加其他标签")]
                                  )
                            ],
                            2
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "online-shop-goods-table bairun-margin-t"
                            },
                            [
                              _c(
                                "draggable",
                                {
                                  staticClass: "draggable-content",
                                  attrs: {
                                    group: "goodsList",
                                    animation: "500",
                                    "chosen-class": "bairun-draggable-chosen"
                                  },
                                  model: {
                                    value: _vm.formData.goodsList,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "goodsList", $$v)
                                    },
                                    expression: "formData.goodsList"
                                  }
                                },
                                [
                                  _c(
                                    "transition-group",
                                    {
                                      attrs: {
                                        type: "transition",
                                        name: "goods-List"
                                      }
                                    },
                                    _vm._l(_vm.formData.goodsList, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            "goods-item-" +
                                            item.spuNo +
                                            "-" +
                                            index,
                                          staticClass:
                                            "goods-item bairun-padding bairun-margin-r bairun-margin-b",
                                          class: { checked: item.checked },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.onCheckedActivityGoodsItem(
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "goods-layout" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "goods-logo" },
                                                [
                                                  _c("el-image", {
                                                    attrs: {
                                                      src: item.imgUrl,
                                                      fit: "contain",
                                                      "preview-src-list": [
                                                        item.imgUrl
                                                      ]
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "goods-info bairun-margin-l"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "bairun-table-goods-name"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.goodsName)
                                                      )
                                                    ]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(_vm._s(item.spuNo))
                                                  ]),
                                                  _c("div", [
                                                    _vm._v(
                                                      "库存：" +
                                                        _vm._s(item.goodsStock)
                                                    )
                                                  ]),
                                                  _c("div", [
                                                    _vm._v(
                                                      "成本：¥" +
                                                        _vm._s(
                                                          item.goodsLatestCost
                                                        )
                                                    )
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "goods-price"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "售价：¥" +
                                                          _vm._s(
                                                            item.goodsPrice
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "goods-titleSub" },
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      "用户购买时显示可选规格名称，默认与spu相同，可修改",
                                                    placement: "top"
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("规格名称：")
                                                  ])
                                                ]
                                              ),
                                              _c("el-input", {
                                                attrs: {
                                                  placeholder: "请输入内容",
                                                  clearable: ""
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.inputChange(
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: item.titleSub,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "titleSub",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.titleSub"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      "用户购买时显示可其他标签，如：大小、尺寸、颜色等",
                                                    placement: "top"
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("其他标签：")
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "goods-size-content",
                                                  staticStyle: {
                                                    display: "inline-block"
                                                  }
                                                },
                                                [
                                                  _vm._l(item.size, function(
                                                    item2,
                                                    index2
                                                  ) {
                                                    return _c(
                                                      "el-tag",
                                                      {
                                                        key: item2,
                                                        attrs: {
                                                          closable: "",
                                                          "disable-transitions": false
                                                        },
                                                        on: {
                                                          close: function(
                                                            $event
                                                          ) {
                                                            return _vm.onDeleteSize(
                                                              item,
                                                              index2
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item2) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  item.goodsSizeVisible
                                                    ? _c("el-input", {
                                                        ref:
                                                          "goodsSizeValue" +
                                                          item.spuNo,
                                                        refInFor: true,
                                                        staticClass:
                                                          "goods-size",
                                                        attrs: {
                                                          size: "small",
                                                          clearable: ""
                                                        },
                                                        on: {
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.onAddSize(
                                                              item
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.inputChange(
                                                              $event
                                                            )
                                                          }
                                                        },
                                                        nativeOn: {
                                                          keyup: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              !$event.type.indexOf(
                                                                "key"
                                                              ) &&
                                                              _vm._k(
                                                                $event.keyCode,
                                                                "enter",
                                                                13,
                                                                $event.key,
                                                                "Enter"
                                                              )
                                                            ) {
                                                              return null
                                                            }
                                                            return _vm.onAddSize(
                                                              item
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.goodsSizeValue,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.goodsSizeValue = $$v
                                                          },
                                                          expression:
                                                            "goodsSizeValue"
                                                        }
                                                      })
                                                    : _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "add-goods-size",
                                                          attrs: {
                                                            size: "small"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onShowInputSize(
                                                                item,
                                                                "goodsSizeValue" +
                                                                  item.spuNo
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("+添加")]
                                                      )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          ),
                                          index === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bairun-rotate-tag"
                                                },
                                                [_c("span", [_vm._v("默认")])]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-image-viewer__btn el-image-viewer__close",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.onDelGoods(item)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-close"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.formData.goodsList.length > 0
            ? _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-form-item", { attrs: { label: "返券活动：" } }, [
                        _c(
                          "div",
                          { staticClass: "bairun-grey-pannel" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "优惠券配置：" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.onAddTicket }
                                  },
                                  [_vm._v("添加")]
                                ),
                                _vm._l(
                                  _vm.formData.selActivityGoodsItem.goodsTicket,
                                  function(item, index) {
                                    return _c(
                                      "el-row",
                                      {
                                        staticClass: "ticket-form-item",
                                        attrs: { gutter: 10 }
                                      },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 6 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "券类型",
                                                  prop:
                                                    "selActivityGoodsItem.goodsTicket." +
                                                    index +
                                                    ".ruleType"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "请选择",
                                                      clearable: ""
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.onTicketRuleTypeChange(
                                                          item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: item.ruleType,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "ruleType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.ruleType"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.ticketRuleTypeOptions,
                                                    function(ruleTypeItem) {
                                                      return _c("el-option", {
                                                        key: ruleTypeItem.value,
                                                        attrs: {
                                                          label:
                                                            ruleTypeItem.label,
                                                          value:
                                                            ruleTypeItem.value
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 10 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "券名称",
                                                  prop:
                                                    "selActivityGoodsItem.goodsTicket." +
                                                    index +
                                                    ".ticketRuleNo"
                                                }
                                              },
                                              [
                                                item.ruleType === 2
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          clearable: "",
                                                          filterable: "",
                                                          remote: "",
                                                          "remote-method": function(
                                                            text
                                                          ) {
                                                            _vm.onSearchTicket(
                                                              item,
                                                              text
                                                            )
                                                          },
                                                          placeholder: "请选择"
                                                        },
                                                        on: {
                                                          change: function(
                                                            value
                                                          ) {
                                                            _vm.onSelTicket(
                                                              value,
                                                              item
                                                            )
                                                          },
                                                          clear: function() {
                                                            _vm.resetTicketOptions(
                                                              item
                                                            )
                                                            _vm.autoCreateActivityInfo()
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            item.ticketRuleNo,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "ticketRuleNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.ticketRuleNo"
                                                        }
                                                      },
                                                      _vm._l(
                                                        item.oilTicketOptions,
                                                        function(ticketItem) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key:
                                                                ticketItem.ticketRuleNo,
                                                              attrs: {
                                                                label:
                                                                  ticketItem.ticketName,
                                                                value:
                                                                  ticketItem.ticketRuleNo
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e(),
                                                item.ruleType === 3
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          clearable: "",
                                                          filterable: "",
                                                          remote: "",
                                                          "remote-method": function(
                                                            text
                                                          ) {
                                                            _vm.onSearchTicket(
                                                              item,
                                                              text
                                                            )
                                                          },
                                                          placeholder: "请选择"
                                                        },
                                                        on: {
                                                          change: function(
                                                            value
                                                          ) {
                                                            _vm.onSelTicket(
                                                              value,
                                                              item
                                                            )
                                                          },
                                                          clear: function() {
                                                            _vm.resetTicketOptions(
                                                              item
                                                            )
                                                            _vm.autoCreateActivityInfo()
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            item.ticketRuleNo,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "ticketRuleNo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.ticketRuleNo"
                                                        }
                                                      },
                                                      _vm._l(
                                                        item.goodsTicketOptions,
                                                        function(ticketItem) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key:
                                                                ticketItem.ticketRuleNo,
                                                              attrs: {
                                                                label:
                                                                  ticketItem.ticketName,
                                                                value:
                                                                  ticketItem.ticketRuleNo
                                                              }
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 4 } },
                                          [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入张数",
                                                min: 1
                                              },
                                              on: {
                                                change:
                                                  _vm.autoCreateActivityInfo
                                              },
                                              model: {
                                                value: item.num,
                                                callback: function($$v) {
                                                  _vm.$set(item, "num", $$v)
                                                },
                                                expression: "item.num"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 4 } },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onDeleteTicket(
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("移除")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onViewTicket(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("查看")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _vm.formData.selActivityGoodsItem
                                      .activityTags &&
                                    _vm.formData.selActivityGoodsItem
                                      .activityTags.length > 0
                                      ? _c(
                                          "el-form-item",
                                          { attrs: { label: "活动标签：" } },
                                          [
                                            _vm._l(
                                              _vm.formData.selActivityGoodsItem
                                                .activityTags,
                                              function(item, index) {
                                                return [
                                                  item.tagType === 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "activity-tag"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.tagIcon
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.tagValue
                                                                  ) +
                                                                    _vm._s(
                                                                      item.tagName
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "详情页返券面额：" } },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [_vm._v("注意：不同关联商品单独配置")]
                                        ),
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 8,
                                            clearable: "",
                                            placeholder:
                                              _vm.formData.selActivityGoodsItem
                                                .activityRemark
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.inputChange($event)
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.formData.selActivityGoodsItem
                                                .activityRemark,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData
                                                  .selActivityGoodsItem,
                                                "activityRemark",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.selActivityGoodsItem.activityRemark"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "详情页返券说明：" } },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "red" } },
                                          [_vm._v("注意：所有关联商品都一样")]
                                        ),
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 8,
                                            clearable: "",
                                            placeholder:
                                              _vm.formData.giveTicketLimit
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.inputChange($event)
                                            }
                                          },
                                          model: {
                                            value: _vm.formData.giveTicketLimit,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "giveTicketLimit",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.giveTicketLimit"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { staticClass: "goods-img-content" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "详情页头图：" } },
                    [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入链接地址",
                              clearable: ""
                            },
                            on: {
                              blur: function($event) {
                                return _vm.onAddImgUrl("bannerImgs")
                              },
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.addBannerImgUrl,
                              callback: function($$v) {
                                _vm.addBannerImgUrl = $$v
                              },
                              expression: "addBannerImgUrl"
                            }
                          })
                        ],
                        1
                      ),
                      _c("upload-image", {
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          "file-size": 200,
                          "is-press": true,
                          "max-w-h": 1080,
                          multiple: true,
                          "auto-upload": true,
                          height: "200px",
                          width: "200px",
                          tips: "尺寸1:1，自动压缩，不超过200kb"
                        },
                        on: { onUploadSuccess: _vm.goodsBannerUploadSuccess }
                      }),
                      _c(
                        "draggable",
                        {
                          staticClass: "draggable-content",
                          attrs: {
                            group: "bannerImgs",
                            animation: "500",
                            "chosen-class": "bairun-draggable-chosen"
                          },
                          model: {
                            value: _vm.formData.bannerImgs,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "bannerImgs", $$v)
                            },
                            expression: "formData.bannerImgs"
                          }
                        },
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                type: "transition",
                                name: "bannerImgs-list"
                              }
                            },
                            _vm._l(_vm.formData.bannerImgs, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "bannerImgs" + index,
                                  staticClass:
                                    "goods-banner-img bairun-margin-l"
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: item,
                                      fit: "fit",
                                      "preview-src-list":
                                        _vm.formData.bannerImgs
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-image-viewer__btn el-image-viewer__close",
                                      on: {
                                        click: function($event) {
                                          return _vm.onDeleteBanner(index)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "el-icon-close" })]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "goods-img-content" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品详情图：" } },
                    [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入链接地址",
                              clearable: ""
                            },
                            on: {
                              blur: function($event) {
                                return _vm.onAddImgUrl("goodsDetailImgs")
                              },
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.addDetailImgUrl,
                              callback: function($$v) {
                                _vm.addDetailImgUrl = $$v
                              },
                              expression: "addDetailImgUrl"
                            }
                          })
                        ],
                        1
                      ),
                      _c("upload-image", {
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          "file-size": 200,
                          "is-press": true,
                          "max-w-h": 1080,
                          multiple: true,
                          "auto-upload": true,
                          height: "200px",
                          width: "200px",
                          tips: "尺寸不限，自动压缩，不超过200kb"
                        },
                        on: { onUploadSuccess: _vm.goodsDetailUploadSuccess }
                      }),
                      _c(
                        "draggable",
                        {
                          staticClass: "draggable-content",
                          attrs: {
                            group: "goodsDetailImgs",
                            animation: "500",
                            "chosen-class": "bairun-draggable-chosen"
                          },
                          model: {
                            value: _vm.formData.goodsDetailImgs,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "goodsDetailImgs", $$v)
                            },
                            expression: "formData.goodsDetailImgs"
                          }
                        },
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                type: "transition",
                                name: "goodsDetailImgs-list"
                              }
                            },
                            _vm._l(_vm.formData.goodsDetailImgs, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "goodsDetailImgs" + index,
                                  staticClass:
                                    "goods-banner-img bairun-margin-l"
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: item,
                                      fit: "fit",
                                      "preview-src-list":
                                        _vm.formData.goodsDetailImgs
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-image-viewer__btn el-image-viewer__close",
                                      on: {
                                        click: function($event) {
                                          return _vm.onDeleteDetailImg(index)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "el-icon-close" })]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bairun-bottom-tool" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function() {
                  _vm.onCache()
                  _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _c("el-button", { on: { click: _vm.onClear } }, [_vm._v("清空")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("提交")]
          )
        ],
        1
      ),
      _vm.goodsComponentFormData.dialogVisible
        ? _c("GoodsSelectComponent", {
            ref: "GoodsSelectComponent",
            attrs: { "goods-component-form-data": _vm.goodsComponentFormData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }